<template>
  <div>
    <Form ref="form" :onSubmit="onSubmit" :onSuccess="onSuccess">

      <h1>{{ options.model.contract_number }} - {{ i18n.app.components.contract_cancellation.dialog.header }}</h1>

      <div>
        <p>
          {{ i18n.app.components.contract_cancellation.dialog.body }}
        </p>
      </div>
      <div>
        <TextInput :model="model" placeholder="Vervalreden" :indent="false" name="reason" minHeight='150px' :multiline="true"/>
      </div>
      <div class="row">
        <div class="col-md-6">
          <a @click="onCancelClick" tabindex="0" class="btn btn-primary">{{ i18n.app.common.cancel }}</a>
        </div>
        <div class="col-md-6 text-right">
          <a @click="onSubmitClick" class="btn btn-secondary">{{ i18n.app.common.confirm }}</a>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
  import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
  import { TextInput, Form } from '@/components/common/form';
  import ContractCancellationService from '@/services/ContractCancellationService';

  export default {
    name: 'contract-cancel-dialog',
    props: ['options'],
    mixins: [DialogMixin],
    components: {
      Form,
      TextInput
    },
    data() {
      return {
        contractCancellationService: new ContractCancellationService(this.options.model.id),
        model: {
          reason: ''
        }
      }
    },
    methods: {
      onSubmitClick() {
        this.$refs.form.submit(this.model);
      },
      onSubmit() {
        return this.contractCancellationService.insert(this.model);
      },
      onSuccess(model) {
        this.proceed();
      },
      onCancelClick() {
        this.cancel(); // included in DialogMixin
      }
    }
  }
</script>
